import React from 'react';
import styled from 'styled-components';
import AdminBlockWithVisible from '../../share/component/AdminBlockWithVisible';
import { useAdminVenueStore } from '../../share/store/adminVenueStore';
import { SortDirection, VenueSortOrder } from '../../../shared/enum/EnumRepository';
import { runAfterVenueListContextChange } from './runAfterUnsavedVenueCheck';

const VenueColumnInfo: React.FC = () => {
  const activeVenue = useAdminVenueStore((state) => state.activeVenue);
  const hasMultiSelected = useAdminVenueStore(
    (state) => state.multiSelectedVenueIds.length > 1,
  );
  const isBulkPreviewOpen = useAdminVenueStore((state) => state.isBulkPreviewOpen);
  const hasBulkResult = useAdminVenueStore(
    (state) => !!state.bulkResult && !state.activeVenue && state.multiSelectedVenueIds.length <= 1,
  );
  const sortData = useAdminVenueStore((state) => state.sortData);
  const setSortData = useAdminVenueStore((state) => state.setSortData);
  const hasViewer = !!activeVenue || hasMultiSelected || isBulkPreviewOpen || hasBulkResult;

  const handleDirectionChange = (field: VenueSortOrder) => {
    runAfterVenueListContextChange(() => {
      if (sortData.sort === field) {
        setSortData({
          ...sortData,
          direction: sortData.direction === SortDirection.ASC
            ? SortDirection.DESC
            : SortDirection.ASC,
        });
        return;
      }
      setSortData({ sort: field, direction: SortDirection.ASC });
    });
  };

  return (
    <ColumnInfoComp>
      <InfoContainer>
        <TitleBlock onClick={() => handleDirectionChange(VenueSortOrder.NAME)}>
          Name
          <SelectDirection
            $isASC={
              sortData.sort === VenueSortOrder.NAME
              && sortData.direction === SortDirection.ASC
            }
            $isSortField={sortData.sort === VenueSortOrder.NAME}
          >
            ▼
          </SelectDirection>
        </TitleBlock>
        <AdminBlockWithVisible
          width="1.5"
          isColumn={true}
          value="Type"
        />
        <AdminBlockWithVisible
          width="1.2"
          isColumn={true}
          value="Admission"
        />
        <AdminBlockWithVisible
          width="2"
          isColumn={true}
          value="City/District"
        />
        <AdminBlockWithVisible
          width="2"
          isColumn={true}
          value="Instagram"
        />
        {hasViewer && <SpaceBlock />}
      </InfoContainer>
      {hasViewer && <OverviewBlock>Overview</OverviewBlock>}
    </ColumnInfoComp>
  );
};

const ColumnInfoComp = styled.article`
  width: 100%;
  height: 38px;
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_02};
  user-select: none;

  ${({ theme }) => theme.typography.Body_03_2};
`;

const InfoContainer = styled.article`
  flex: 1;
  width: auto;
  height: 34px;
  display: flex;
`;

const TitleBlock = styled.div`
  flex: 2.4;
  display: flex;
  align-items: center;
  padding-left: 4px;
  cursor: pointer;
`;

const SelectDirection = styled.span<{ $isSortField: boolean; $isASC: boolean }>`
  margin-left: 4px;
  user-select: none;
  ${({ theme }) => theme.typography.Footer_02};
  color: ${({ theme, $isSortField }) =>
    $isSortField ? theme.colors.color_Gray_03 : theme.colors.color_Gray_05};
  transform: ${({ $isASC, $isSortField }) => {
    if (!$isSortField) return 'scale(0.7)';
    return $isASC ? 'scale(0.7)' : 'scaleY(-1) scale(0.7)';
  }};
  transition: transform 0.6s ease-in-out;
`;

const SpaceBlock = styled.div`
  flex: 0.15;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const OverviewBlock = styled.div`
  flex: 0 0 29vw;
  width: 29vw;
  min-width: 29vw;
  display: flex;
  align-items: center;
`;

export default VenueColumnInfo;
